import { authClient } from './client';
import ExtractErrorMessage from "../utils/extractErrorMessage";

const agentService = {

    getAll: async (page = 1, limit = 10, search = undefined, status = undefined) => {
        const params = new URLSearchParams();
        params.append('page', page.toString());
        params.append('limit', limit.toString());

        if (search) params.append('search', search);
        if (status) params.append('status', status);

        try {
            return (await authClient.get(`/agents?${params.toString()}`)).data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške");
            return { data: null, success: false, message: message };
        }
    },

    getDetails: async (id) => {
        try {
            return (await authClient.get(`/agents/${id}`)).data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške");
            return { data: null, success: false, message: message };
        }
    },

    listPromotableUsers: async ({ page = 1, limit = 20, search = null } = {}) => {
        try {
            let query = `?page=${page}&limit=${limit}`;
            if (search) query += `&search=${encodeURIComponent(search)}`;

            const response = await authClient.get(`/agents/promotable-users${query}`);
            return response.data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške pri dobavljanju korisnika.");
            return { data: null, success: false, message: message };
        }
    },

    promote: async (payload) => {
        try {
            const response = await authClient.post('/agents/promote', payload);
            return response.data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške pri postavljanju korisnika za agenta.");
            return { data: null, success: false, message: message };
        }
    },

    create: async (data) => {
        try {
            return (await authClient.post('/agents', data)).data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške");
            return { data: null, success: false, message: message };
        }
    },

    update: async (id, data) => {
        try {
            return (await authClient.patch(`/agents/${id}`, data)).data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške");
            return { data: null, success: false, message: message };
        }
    },

    deactivate: async (id) => {
        try {
            return (await authClient.delete(`/agents/${id}`)).data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške");
            return { data: null, success: false, message: message };
        }
    },

    activate: async (id) => {
        try {
            return (await authClient.patch(`/agents/${id}`, { status: 'ACTIVE' })).data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške");
            return { data: null, success: false, message: message };
        }
    },

    getCommissionLedger: async (id, page = 1, limit = 10, month = undefined) => {
        const params = new URLSearchParams();
        params.append('page', page.toString());
        params.append('limit', limit.toString());
        if (month) params.append('month', month);

        try {
            return (await authClient.get(`/agents/${id}/commission-ledger?${params.toString()}`)).data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške");
            return { data: null, success: false, message: message };
        }
    },

    getOrders: async (id, params) => {
        try {
            const response = await authClient.get(`/agents/${id}/orders`, { params });
            return response.data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške pri dobavljanju porudžbina agenta.");
            return { data: null, success: false, message: message };
        }
    },

    exportOrders: async (id, params) => {
        try {
            const response = await authClient.get(`/agents/${id}/orders/export`, {
                params: params,
                responseType: 'blob',
            });
            return { success: true, data: response.data, message: null };
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške pri izvozu porudžbina.");
            return { data: null, success: false, message: message };
        }
    },

    markPayoutEntryStatus: async (agentId, entryId, status) => {
        try {
            const response = await authClient.patch(
                `/agents/${agentId}/commission-ledger/${entryId}/status`,
                { status }
            );
            return response.data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške pri izmeni statusa provizije.");
            return { data: null, success: false, message: message };
        }
    },

    markPayoutEntriesBulk: async (agentId, entryIds, status) => {
        try {
            const response = await authClient.patch(
                `/agents/${agentId}/commission-ledger/bulk-status`,
                { entryIds, status }
            );
            return response.data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške pri izmeni statusa provizije.");
            return { data: null, success: false, message: message };
        }
    },
};

export default agentService;
